import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useAdminRole } from '@/hooks/useAdminRole';
import { roleIncludes, type AdminRole } from '@/lib/admin/permissions';
import { consoleLabelForRole, isStaffRole } from '@/lib/admin/roles';

interface RoleGateProps {
  allow: AdminRole[];
  children: ReactNode;
  /** 未登入或 member 时的提示标题 */
  deniedTitle?: string;
}

export default function RoleGate({ allow, children, deniedTitle }: RoleGateProps) {
  const { role, loading } = useAdminRole();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-secondary-400">
        验证权限中…
      </div>
    );
  }

  if (!role || !roleIncludes(allow, role)) {
    const isMember = role === 'member' || !role;
    const title = deniedTitle ?? (isMember ? '此页仅限管理员' : '权限不足');
    const hint = isMember
      ? '如需协助请联络管理员。'
      : isStaffRole(role!)
        ? `你的角色为「${consoleLabelForRole(role!)}」，无法访问此页面。`
        : '请使用有权限的帐号登入。';

    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-3 px-4">
        <i className="ri-lock-2-line text-3xl text-secondary-300" />
        <p className="text-sm font-medium text-foreground-700">{title}</p>
        <p className="text-xs text-secondary-500 text-center max-w-sm">{hint}</p>
        <Link to="/" className="text-xs text-primary-600 hover:underline">返回工作台</Link>
      </div>
    );
  }

  return <>{children}</>;
}
